<template>
	<div id="press-releases-article">
		<div class="container">
			<div class="breadcrumbs">
				<div class="breadcrumbs__item">{{ $t('main.press-releases.about-nexon') }}</div>
				<div class="breadcrumbs__separator"></div>
				<div class="breadcrumbs__item">{{ $t('main.press-releases.title') }}</div>
			</div>

			<div v-if="loading" class="spinner-wrapper">
				<div class="spinner-circle"></div>
			</div>

			<div v-else class="press-article">
				<div class="press-article__header">
					<div :class="article.Category.toLowerCase().replace(/\s/g, '')">{{ article.Category }}</div>
					<div>{{ article.LiveDate | formatedDate }}</div>
				</div>
				<h1 class="press-article__title">{{ article.Title }}</h1>
				<!-- eslint-disable-next-line vue/no-v-html -->
				<div class="press-article__content" v-html="article.Body" />
			</div>

			<div class="links">
				<router-link :to="{ name: 'pressReleases' }">
					{{ $t('main.press-releases.title') }}
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';

export default {
	name: 'PressReleasesArticle',
	metaInfo() {
		return {
			titleTemplate: `%s | ${this.$t('main.about-nexon.press-releases')}`,
		};
	},
	filters: {
		formatedDate: (date) => {
			return moment(date).format('MMM D, YYYY');
		},
	},
	data() {
		return {
			loading: false,
			article: {},
		};
	},
	created() {
		this.loading = true;
		this.$cdnAPI
			.get(`corporate/press/${this.$route.params.articleId}`)
			.then((response) => {
				this.article = response.data;
				this.loading = false;
			})
			.catch((error) => {
				if (error.response && error.response.status && error.response.status === 403) {
					this.$router.push({ name: 'pressReleases' });
				}
			});
	},
};
</script>

<style lang="scss" scoped>
@font-face {
	font-family: arrow-icons;
	src: url('data:application/font-woff;charset=utf-8;base64, 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');
	font-weight: 400;
	font-style: normal;
}

b,
h1,
h2,
h3,
h4,
h5,
h6,
strong {
	font-family: Lucida Grande, Lucida Sans Unicode, Tahoma, sans-serif;
}

#press-releases-article {
	background-color: #121212;
	background-repeat: no-repeat;
	background-image: radial-gradient(circle at top, #276a60, #1a3530, #15191a, #121212 35%);
	line-height: normal;
	padding-top: 56px;
	padding-bottom: 100px;
	line-height: normal;

	.container {
		max-width: 1024px;
		width: 100%;
		margin: 0 auto;
		padding-bottom: 100px;
		font-size: 12px;
		padding: 0;
	}

	.breadcrumbs {
		display: flex;
		font-size: 18px;
		margin: 20px 0 0;
		&__item {
			color: #fff;
			text-decoration: none;
		}
		&__separator {
			margin: 3px 20px 0;
			width: 2px;
			height: 14px;
			background-color: #22544b;
		}
	}

	.press-article {
		margin-top: 50px;
		&__header {
			display: flex;
			flex-wrap: wrap;
			padding: 20px 0;
			font-size: 18px;
			> div {
				&:first-child {
					color: #fff;
					text-transform: uppercase;
				}
				&:last-child {
					color: #adadad;
					margin-left: 40px;
				}
			}
		}
		&__title {
			border-top: 2px solid #1f423e;
			color: #fff;
			font-size: 30px;
			line-height: 40px;
			padding-top: 20px;
			margin-top: 0px;
		}
		&__content ::v-deep {
			margin-top: 20px;
			color: #adadad;
			font-size: 16px;
			line-height: normal;
			padding-bottom: 20px;
			border-bottom: 2px solid #1f423e;

			b,
			h1,
			h2,
			h3,
			h4,
			h5,
			h6,
			strong {
				font-family: Lucida Grande, Lucida Sans Unicode, Tahoma, sans-serif;
			}

			img {
				max-width: 100%;
				height: auto;
				border: solid 1px #3bbeac;
			}

			p {
				line-height: 25px;
				margin: 10px 0;
			}

			a {
				text-decoration: none;
				color: #40d0ba;
				font-weight: bold;
			}

			h1 {
				color: #fff;
				font-size: 30px;
				line-height: 40px;
				font-weight: normal;
				margin: 10px 0;
			}

			h2 {
				color: #fff;
				font-size: 24px;
				font-weight: normal;
				margin: 10px 0;
				line-height: normal;
			}

			strong {
				color: #fff;
			}

			ul {
				margin-left: 16px;
				line-height: normal;
			}
		}
	}

	.general {
		color: #fff !important;
	}
	.maplestory {
		color: #9d352c !important;
	}
	.maplestory2 {
		color: #ffea3c !important;
	}
	.maplestorym {
		color: #e67d39 !important;
	}
	.mabinogi {
		color: #80dafd !important;
	}

	.links {
		display: flex;
		flex-wrap: wrap;
		flex: 0 1 auto;
		line-height: normal;
		justify-content: center;
		margin-top: 100px;
		font-family: 'KlavikaNX Light';

		a {
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: #fff;
			color: #212121;
			min-width: 310px;
			padding: 10px 20px;
			text-transform: uppercase;
			font-size: 24px;
			border-radius: 40px;
			text-decoration: none;
			transition: 0.2s;
			&:hover {
				background-color: #40d0ba;
			}
			&:before {
				font-family: arrow-icons;
				text-transform: none;
				content: 'prev';
				font-size: 18px;
				margin-right: 20px;
			}
		}
	}
	.spinner-wrapper {
		display: flex;
		justify-content: center;
		padding: 300px 0;
		.spinner-circle {
			width: 60px;
			height: 60px;
			border: 10px solid #999;
			border-top: 10px solid #0077ff;
		}
	}
}

@media only screen and (max-width: 1024px) {
	#press-releases-article {
		.container {
			max-width: 100%;
			padding-left: 20px;
			padding-right: 20px;

			.breadcrumbs {
				line-height: normal;
				font-size: 16px;
				&__item {
					padding: 0;
				}
				&__separator {
					margin: 3px 10px 0;
				}
			}

			.links {
				margin-top: 50px;
				a {
					min-width: 360px;
					font-size: 16px;
					&:before {
						font-size: 14px;
						margin-right: 10px;
					}
				}
			}
		}
	}
}

@media (max-width: 500px) {
	#press-releases-article {
		.container {
			.links {
				a {
					min-width: 100%;
					width: 100%;
				}
			}
		}
	}
}
</style>
